module.exports = __webpack_public_path__ + "img/divide-cross-icon.0f8bf581.svg";